import Settings from 'configs/Settings';
import { createBrowserHistory } from 'history';
import difference from 'lodash/difference';

import { ROUTE_NAMESPACES, ROUTES } from './constants';
import { getPageTitle } from './pageTitles';

export const allFullPageRoutes = [ROUTES.CONTENT.IMPORT];

export const getHistory = (basename) => {
  return createBrowserHistory({
    basename: (basename || '') + Settings.subpath
  });
};

export const isInternalPathname = (pathname, isCreateModuleConceptEnabled) => {
  const disabledInternalRoutes = [ROUTE_NAMESPACES.REPORTS];

  if (isCreateModuleConceptEnabled) {
    disabledInternalRoutes.push(ROUTE_NAMESPACES.MODULE);
  }

  const routeNamespacesWithInternalRoutes = difference(
    Object.values(ROUTE_NAMESPACES),
    disabledInternalRoutes
  );

  const routeNamespacesGroup = routeNamespacesWithInternalRoutes.join('|');
  const regExp = new RegExp(`(/admin/beta)?(${routeNamespacesGroup})/(.)+`);

  return Boolean(pathname.match(regExp));
};

const isFullPagePathname = (pathname) => {
  return allFullPageRoutes.includes(pathname);
};

export const registerHistoryChangeEventDispatcher = (
  history,
  isCreateModuleConceptEnabled
) => {
  const dispatch = (location) => {
    const { pathname, search, hash } = location;

    window.dispatchEvent(
      new CustomEvent('clubhistorychange', {
        detail: {
          pathname,
          search,
          hash,
          title: getPageTitle(pathname),
          isInternal: isInternalPathname(
            pathname,
            isCreateModuleConceptEnabled
          ),
          isFullPage: isFullPagePathname(pathname)
        }
      })
    );
  };

  const unregister = history.listen(dispatch);

  dispatch(history.location);

  return unregister;
};
